/* Custom-Song Funnel — storefront logic (theme asset).
 *
 * Multi-step quiz -> live personalized lyric preview (song-API) -> style samples
 * -> NATIVE Shopify <product-form> add-to-cart (theme cart drawer).
 *
 * Progress bars are painted as a background gradient on a zero-width-space
 * element: the theme's base.css hides `div:empty` (display:none), so an empty
 * fill div disappears — we paint the track itself instead.
 */
(function () {
  "use strict";

  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var fmtTime = function (s) { if (!isFinite(s)) return "0:00"; var m = Math.floor(s / 60), ss = Math.floor(s % 60); return m + ":" + (ss < 10 ? "0" : "") + ss; };
  // Paint 0..pct of the track with the foreground colour; rail shows through the rest.
  function paintBar(el, pct) {
    if (!el) return;
    var fg = el._fg || (el._fg = getComputedStyle(el).color);
    el.style.backgroundImage = "linear-gradient(to right, " + fg + " " + pct + "%, transparent " + pct + "%)";
  }

  var STEPS = [
    { type: "intro" },
    { type: "text", key: "recipientName", eyebrow: "Let's begin", q: "Who is this song for?", placeholder: "Their first name", required: true },
    { type: "choice", key: "relationship", q: "Who are they to you?", options: ["My wife", "My husband", "My girlfriend", "My boyfriend", "My partner", "My mom", "My dad", "My best friend", "Someone else"] },
    { type: "choice", key: "occasion", q: "What's the occasion?", options: ["Anniversary", "Valentine's Day", "Wedding", "Birthday", "Just because", "In memory"] },
    { type: "textarea", key: "story", q: "Tell us your story.", help: "How you met, a favourite memory, an inside joke — a sentence is plenty.", placeholder: "The first time we met was…", required: true },
    { type: "textarea", key: "loveAbout", q: "What do you love about them?", help: "A few things — big or small.", placeholder: "The way they…" },
    { type: "choice", key: "tone", q: "What should it feel like?", options: ["Romantic", "Heartfelt", "Playful", "Upbeat"] },
    { type: "choice", key: "genre", q: "Pick a style.", options: ["R&B", "Acoustic Pop", "Soul", "Country", "Pop Ballad"] },
    { type: "choice", key: "singer", q: "Whose voice sings it?", options: ["A female voice", "A male voice"] },
    { type: "crafting" },
    { type: "reveal" }
  ];
  var QUESTION_COUNT = STEPS.filter(function (s) { return s.key; }).length;

  function initFunnel(configEl) {
    var root = configEl.closest("[data-cs-root]") || configEl.closest("section") || configEl.parentNode;
    var mount = root.querySelector("[data-cs-mount]");
    var hdrBar = root.querySelector("[data-cs-progress]");
    var hdrPct = root.querySelector("[data-cs-pct]");
    var hdrTitle = root.querySelector("[data-cs-title]");
    var pagehead = root.querySelector("[data-cs-pagehead]");
    var cfg; try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
    cfg.proof = Array.isArray(cfg.proof) ? cfg.proof : [];

    var answers = {}, index = 0, preview = null, tier = "standard";

    function setHeader(pct, title) {
      pct = Math.max(0, Math.min(100, Math.round(pct)));
      if (hdrPct) hdrPct.textContent = pct + "%";
      paintBar(hdrBar, pct);
      if (title && hdrTitle) hdrTitle.textContent = title;
    }
    function quizPct() { return (STEPS.slice(0, index).filter(function (s) { return s.key; }).length / QUESTION_COUNT) * 100; }
    function go(next) { index = next; render(); }

    function render() {
      var step = STEPS[index];
      // The page header (title + bar) is the quiz progress indicator; hide it at
      // crafting/reveal so it doesn't duplicate the crafting screen's own bar.
      var hideHead = step.type === "crafting" || step.type === "reveal";
      if (pagehead) pagehead.style.display = hideHead ? "none" : "";
      if (!hideHead) setHeader(quizPct(), "Customize Your Song");
      mount.innerHTML = "";
      var el = step.type === "intro" ? renderIntro() : step.type === "choice" ? renderChoice(step) :
        step.type === "crafting" ? renderCrafting() : step.type === "reveal" ? renderReveal() : renderInput(step);
      el.classList.add("cs-step");
      mount.appendChild(el);
    }

    function renderIntro() {
      var d = document.createElement("div");
      d.innerHTML = '<p class="cs-eyebrow">One of a kind</p><h2 class="cs-q">' + esc(cfg.heading) + "</h2>" +
        '<p class="cs-help">Answer a few questions and we\'ll write you a personalized preview — on the spot — before you decide.</p>' +
        '<div class="cs-nav"><span></span><button class="cs-btn" data-next>Start</button></div>';
      d.querySelector("[data-next]").addEventListener("click", function () { go(1); });
      return d;
    }

    function renderInput(step) {
      var d = document.createElement("div");
      var tag = step.type === "textarea" ? "textarea" : "input";
      d.innerHTML = (step.eyebrow ? '<p class="cs-eyebrow">' + esc(step.eyebrow) + "</p>" : "") +
        '<h2 class="cs-q">' + esc(step.q) + "</h2>" +
        "<" + tag + ' class="cs-' + (step.type === "textarea" ? "textarea" : "input") + '" data-field placeholder="' + esc(step.placeholder || "") + '"' +
        (step.type === "textarea" ? "></textarea>" : "/>") +
        (step.help ? '<p class="cs-help">' + esc(step.help) + "</p>" : "") +
        '<div class="cs-nav"><button class="cs-link" data-back>Back</button><button class="cs-btn" data-next disabled>Continue</button></div>';
      var field = d.querySelector("[data-field]");
      field.value = answers[step.key] || "";
      var next = d.querySelector("[data-next]");
      function validate() { next.disabled = step.required ? field.value.trim().length === 0 : false; } // no character minimum
      field.addEventListener("input", validate); validate(); field.focus();
      next.addEventListener("click", function () { answers[step.key] = field.value.trim(); go(index + 1); });
      d.querySelector("[data-back]").addEventListener("click", function () { answers[step.key] = field.value.trim(); go(index - 1); });
      return d;
    }

    function renderChoice(step) {
      var d = document.createElement("div");
      d.innerHTML = '<h2 class="cs-q">' + esc(step.q) + "</h2><div class=\"cs-choices\">" +
        step.options.map(function (o) { return '<button class="cs-choice' + (answers[step.key] === o ? " is-selected" : "") + '" data-opt="' + esc(o) + '">' + esc(o) + "</button>"; }).join("") +
        '</div><div class="cs-nav"><button class="cs-link" data-back>Back</button><span></span></div>';
      d.querySelectorAll("[data-opt]").forEach(function (b) { b.addEventListener("click", function () { answers[step.key] = b.getAttribute("data-opt"); go(index + 1); }); });
      d.querySelector("[data-back]").addEventListener("click", function () { go(index - 1); });
      return d;
    }

    function renderCrafting() {
      var d = document.createElement("div");
      d.className = "cs-craft";
      d.innerHTML = '<div class="cs-orb"></div><h2 class="cs-q">Crafting ' + esc(answers.recipientName || "their") + "'s lyrics…</h2>" +
        '<p class="cs-craftpct" data-cpct>0%</p><div class="cs-craftbar" data-cbar>​</div>' +
        '<p class="cs-craft__status" data-status>Reading your story…</p>' +
        (cfg.proof.length ? '<div class="cs-craft__proof">' + cfg.proof.map(function (p, i) {
          return '<figure class="cs-proofcard' + (i === 0 ? " is-active" : "") + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : "") + "<figcaption>" + esc(p.text) + "</figcaption></figure>";
        }).join("") + "</div>" : "") +
        '<div class="cs-error cs-hidden" data-err></div>';

      var cbar = d.querySelector("[data-cbar]"), cpct = d.querySelector("[data-cpct]");
      var STATUS = ["Reading your story…", "Finding the melody…", "Choosing the right words…", "Shaping the verse…", "Writing your chorus…", "Almost there…"];
      var statusEl = d.querySelector("[data-status]"), cards = [].slice.call(d.querySelectorAll(".cs-proofcard"));
      var si = 0, pi = 0, start = Date.now(), CM = cfg.craftMs || 60000;
      var tick = setInterval(function () {
        var p = Math.min(100, ((Date.now() - start) / CM) * 100);
        cpct.textContent = Math.round(p) + "%"; paintBar(cbar, p);
      }, 100);
      var rotate = setInterval(function () {
        si = (si + 1) % STATUS.length; statusEl.textContent = STATUS[si];
        if (cards.length) { cards[pi].classList.remove("is-active"); pi = (pi + 1) % cards.length; cards[pi].classList.add("is-active"); }
      }, 3200);

      var timerDone = false, fetchDone = false, failed = false;
      function done() { if (fetchDone && timerDone && !failed) { clearInterval(tick); clearInterval(rotate); go(STEPS.length - 1); } }
      setTimeout(function () { timerDone = true; done(); }, CM);
      fetchPreview().then(function (data) { preview = data; fetchDone = true; done(); }).catch(function () {
        failed = true; clearInterval(tick); clearInterval(rotate);
        // Always generic — never surface raw backend/API error text to the customer.
        var e = d.querySelector("[data-err]"); e.textContent = "We couldn't finish your preview just now. Please try again."; e.classList.remove("cs-hidden");
        statusEl.innerHTML = '<button class="cs-btn cs-btn--ghost" data-retry>Try again</button>';
        d.querySelector("[data-retry]").addEventListener("click", function () { go(index); });
      });
      return d;
    }

    function renderReveal() {
      var d = document.createElement("div");
      var name = answers.recipientName || "them";
      var samples = pickSamples(answers.genre, cfg.samples);
      d.innerHTML = '<p class="cs-eyebrow">Your preview</p><h2 class="cs-q">Here\'s the start of ' + esc(name) + "'s song</h2>" +
        '<div class="cs-lyrics">' + esc((preview && preview.verse) || "") + '</div><div class="cs-flourish">✦ ✦ ✦</div>' +
        '<div class="cs-lyrics">' + esc((preview && preview.chorus) || "") + "</div>" +
        '<div class="cs-locked"><div class="cs-locked__lines"><span></span><span></span><span></span></div>' +
        '<p class="cs-locked__label"><strong>This is just the opening.</strong> Your full song — more verses, a personalized bridge, and studio-recorded vocals — is written and produced after you order, delivered in 72 hours.</p></div>' +
        (samples.length ? '<h3 class="cs-subhead">Hear the quality others got</h3><div class="cs-samples">' + samples.map(sampleHtml).join("") + "</div>" : "") +
        '<div class="cs-buy"><div class="cs-tiers">' + tierHtml("standard", "Standard", cfg.delivery.standard, cfg.prices.standard) + tierHtml("express", "Express", cfg.delivery.express, cfg.prices.express) + "</div>" +
          '<product-form>' +
            '<form action="' + esc(cfg.cartAddUrl || "/cart/add") + '" method="post" enctype="multipart/form-data" novalidate>' +
              '<input type="hidden" name="id" value="' + esc(cfg.variants.standard) + '" data-variant>' +
              '<input type="hidden" name="properties[Song for]" value="' + esc(answers.recipientName || "") + '">' +
              '<input type="hidden" name="properties[From]" value="' + esc(answers.relationship || "") + '">' +
              '<input type="hidden" name="properties[Occasion]" value="' + esc(answers.occasion || "") + '">' +
              '<input type="hidden" name="properties[Style]" value="' + esc(answers.genre || "") + '">' +
              '<input type="hidden" name="properties[Voice]" value="' + esc(answers.singer || "") + '">' +
              '<input type="hidden" name="properties[Brief ID]" value="' + esc((preview && preview.briefId) || "") + '">' +
              '<button type="submit" name="add" class="cs-atc"><span data-atc-label>Add to Cart — ' + esc(cfg.prices.standard) + "</span>" +
                '<div class="loading-overlay__spinner hidden"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>' +
              "</button>" +
            "</form>" +
          "</product-form></div>";

      wireSamples(d);
      var variantInput = d.querySelector("[data-variant]"), label = d.querySelector("[data-atc-label]");
      d.querySelectorAll("[data-tier]").forEach(function (el) {
        el.addEventListener("click", function () {
          tier = el.getAttribute("data-tier");
          d.querySelectorAll("[data-tier]").forEach(function (x) { x.classList.toggle("is-selected", x === el); });
          variantInput.value = cfg.variants[tier]; label.textContent = "Add to Cart — " + cfg.prices[tier];
        });
      });
      // Fire a Meta AddToCart on submit — the theme's page pixels don't track Ajax cart adds on their own.
      var pform = d.querySelector("product-form form");
      if (pform) pform.addEventListener("submit", function () {
        if (typeof window.fbq === "function") {
          var val = parseFloat(String(cfg.prices[tier]).replace(/[^0-9.]/g, "")) || 0;
          window.fbq("track", "AddToCart", { content_type: "product", content_ids: [String(cfg.variants[tier])], value: val, currency: "USD" });
        }
      });
      return d;
    }

    function tierHtml(key, label, delivery, price) {
      return '<button type="button" class="cs-tier' + (key === tier ? " is-selected" : "") + '" data-tier="' + key + '">' +
        '<span class="cs-tier__top"><span>' + esc(label) + "</span><span>" + esc(price) + '</span></span><span class="cs-tier__sub">' + esc(delivery) + "</span></button>";
    }

    function sampleHtml(s, i) {
      return '<div class="cs-sample" data-sample="' + i + '"><button class="cs-sample__play" data-play aria-label="Play">▶</button>' +
        '<div class="cs-sample__body"><div class="cs-sample__meta"><span class="cs-sample__title">' + esc(s.title) + '</span><span class="cs-sample__note">' + esc(s.note) + "</span></div>" +
        '<div class="cs-seek" data-seek>​</div><div class="cs-sample__time"><span data-cur>0:00</span><span data-dur>0:00</span></div></div>' +
        '<audio preload="none" src="' + esc(s.audio) + '"></audio></div>';
    }

    function wireSamples(scope) {
      scope.querySelectorAll("[data-sample]").forEach(function (wrap) {
        var audio = wrap.querySelector("audio"), play = wrap.querySelector("[data-play]"), seek = wrap.querySelector("[data-seek]");
        var cur = wrap.querySelector("[data-cur]"), dur = wrap.querySelector("[data-dur]");
        play.addEventListener("click", function () {
          scope.querySelectorAll("audio").forEach(function (a) { if (a !== audio) a.pause(); });
          scope.querySelectorAll("[data-play]").forEach(function (b) { if (b !== play) b.textContent = "▶"; });
          if (audio.paused) { audio.play(); play.textContent = "❚❚"; } else { audio.pause(); play.textContent = "▶"; }
        });
        audio.addEventListener("loadedmetadata", function () { dur.textContent = fmtTime(audio.duration); });
        audio.addEventListener("timeupdate", function () { paintBar(seek, audio.duration ? (audio.currentTime / audio.duration) * 100 : 0); cur.textContent = fmtTime(audio.currentTime); });
        audio.addEventListener("ended", function () { play.textContent = "▶"; paintBar(seek, 0); });
        seek.addEventListener("click", function (e) { var r = seek.getBoundingClientRect(); if (audio.duration) audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration; });
      });
    }

    function fetchPreview() {
      if (!cfg.apiBase) return Promise.reject(new Error("Song API is not configured."));
      return fetch(cfg.apiBase.replace(/\/$/, "") + "/api/preview-lyrics", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ recipientName: answers.recipientName, relationship: answers.relationship, occasion: answers.occasion, story: answers.story, loveAbout: answers.loveAbout, tone: answers.tone, genre: answers.genre, singer: answers.singer })
      }).then(function (r) { return r.json().then(function (b) { if (!r.ok) throw new Error(b.error || "Preview failed."); return b; }); });
    }

    // Scroll-to-top CTA below the social proof.
    var startCta = root.querySelector("[data-cs-scrolltop]"), card = root.querySelector("[data-cs-card]");
    if (startCta && card) startCta.addEventListener("click", function () { card.scrollIntoView({ behavior: "smooth", block: "start" }); });

    render();
  }

  function pickSamples(genre, samples) {
    samples = Array.isArray(samples) ? samples.filter(function (s) { return s && s.audio; }) : [];
    if (!samples.length) return [];
    var g = String(genre || "").toLowerCase();
    var matched = samples.filter(function (s) { return g && String(s.genre || "").toLowerCase().indexOf(g) !== -1; });
    return (matched.length ? matched : samples).slice(0, 4);
  }

  function boot() { document.querySelectorAll("[data-cs-config]").forEach(initFunnel); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
